export const searchActivitiesFavorite = (activities: string[]) => {
  const experiencesTypes = [
    { id: "1", label: "Food & Drinks" },
    { id: "2", label: "Museums & Galleries"},
    { id: "3", label: "Outdoors"},
    { id: "4", label: "Shows & Concerts"},
    { id: "5", label: "Sight-see & Tours"},
    { id: "6", label: "Sport Events"},
    { id: "7", label: "Volunteering"},
    { id: "8", label: "Fitness & Wellness"},
  ];

  const activitiesFavorite = experiencesTypes.filter((type) => activities.includes(type.id));

  return activitiesFavorite.map((activity) => activity.label).join(', ');
}

export const handlerSearchGeneder = (gender: string) => {
  const genders = [
    {
      id: "1",
      label: "Female",
    },
    {
      id: "2",
      label: "Male",
    },
    {
      id: "3",
      label: "Non-Binary",
    },
    {
      id: "4",
      label: "Prefer not to say",
    },
  ];

  return genders.find((item) => item.id === gender)?.label;
}